<template>
  <v-layout wrap class="custom-header">
    <header-values
      v-for="(item, index) in items"
      :key="index"
      v-bind="item"
      @clickHandler="item.clickHandler()"></header-values>
  </v-layout>
</template>

<script>
import HeaderValues from "@/components/shared/framework/cards/HeaderValues.vue"

export default {
  name: "PlayerStatusHeader",
  components: {
    HeaderValues,
  },
  data() {
    return {
      items: [
        {
          layout: "left-side",
          icon: {
            path: require("@/assets/logos/BackBtn@3x.png").default,
          },
          clickHandler: () => {
            this.$store.getters["user/isCoach"]
              ? this.$router.go(-1)
              : this.$router.push("/")
          },
        },
        {
          title: "Player Status",
          layout: "middle",
        },
        this.$store.getters["user/isPlayer"] && {
          layout: "right-side",
          icon: {
            path: require("@/assets/icons/add_report.png").default,
          },
          clickHandler: () => {
            this.$router.push({ name: "AddReport" })
          },
        },
      ],
    }
  },
}
</script>

<style scoped lang="sass">
// @import '@/assets/sass/globals.sass'
</style>
